import { RArray } from "../../../collections";
import { makeImmutable } from "../../../core";
function assignUnknownWeights(input, unknownFraction) {
    const unknownCount = input.count(([_, weight]) => weight === null);
    const knownTotal = input
        .mapOptional(([_, weight]) => weight)
        .reduce((acc, weight) => acc + weight, 0);
    const knownScaleFactor = knownTotal > 0 ? (1.0 - unknownFraction) / knownTotal : 0;
    const weightForUnknown = unknownCount > 0 ? unknownFraction / unknownCount : 0;
    return input.map(([el, weight]) => weight === null ? [el, weightForUnknown] : [el, weight * knownScaleFactor]);
}
function random(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}
function weightedRandomShuffle(sequenceNumber, input) {
    return input
        .map(([el, weight], index) => [
        el,
        -Math.pow(random(sequenceNumber + index), 1 / weight),
    ])
        .sorted(([, a], [, b]) => a - b)
        .map(([el]) => el);
}
export class AutomaticCrossSellingListProvider {
    constructor(params) {
        this.productCategoryIds = params.productCategoryIds;
        this.candidateCrossSellingItemTypes = params.candidateCrossSellingItemTypes;
        this.weights = params.weights;
        makeImmutable(this);
    }
    items(inputProductTypeIds, sequenceNumber) {
        if (inputProductTypeIds.isEmpty) {
            return RArray.empty();
        }
        const inputCategoryIds = new RArray(inputProductTypeIds).map((productTypeId) => this.productCategoryIds.get(productTypeId));
        const inputWeightSources = inputCategoryIds.mapOptional((productCategoryId) => this.weights.find(productCategoryId));
        const weightedCandidatesWithMissingWeights = new RArray(this.candidateCrossSellingItemTypes.entries).map(([productTypeId, crossSellingItemType]) => {
            const weight = inputWeightSources
                .mapOptional((inputWeightSource) => inputWeightSource.find(productTypeId))
                .reduce((acc, curr) => acc + curr, 0);
            return [crossSellingItemType, weight > 0 ? weight : null];
        });
        const weightedCandidates = assignUnknownWeights(weightedCandidatesWithMissingWeights, 0.2);
        return weightedRandomShuffle(sequenceNumber, weightedCandidates);
    }
}
